module.exports = __webpack_public_path__ + "img/img (28).7a6e305f.png";